module.exports = __webpack_public_path__ + "img/spott_salta.fb1e0309.jpg";